import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsYelpComponent } from './simple-icons-yelp.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsYelpComponent ],
    exports:      [ SimpleIconsYelpComponent ],
    bootstrap:    []
})
export class SimpleIconsYelpModule {}
